const styles = theme => ({
    mntrTxt: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontWeight: 500,
        lineHeight: '20px ! important'
    },
    card: {
        backgroundColor: '#131E2E',
        color: '#fff',
        margin: '10px',
        borderRadius: '8px',
        // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow effect
        minWidth: '150px',
        textAlign: 'center',
    },
    title: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '16px ! important',
        fontWeight: 500,
    },
    value: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '16px ! important',
        fontWeight: 500,
        marginTop: '10px'
    },
    icon: {
        fontSize: '40px', 
        marginBottom: '8px',
    },
    numberOfCallersIcon: {
        color: '#4caf50',
    },
    onCallIcon: {
        color: '#f44336',
    },
    idleIcon: {
        color: '#2196f3',
    },
    breakIcon: {
        color: '#ff9800',
    },

    tbleHeadTxt: {
        // width: '132px ',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        letterSpacing: '0.5px !important',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important'
    },

    hrzntlTabLyt: {
        width: '99% ! important',
        marginTop: '10px',
        flexShrink: 0,
        borderRadius: '10px',
        background: '#131E2E',
        overflowY: 'auto'
    },

    rowText: {
        color: 'var(--b, #FFF)  ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px  ! important',
        letterSpacing: '0.5px !important',
        fontWeight: '400  ! important',
        lineHeight: '18px  ! important'
    }
})

export default styles